import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import TextWCardList from "./TextWCardList";
import { mapProduct, mapProductRetail } from "../../util";
import { useQueryParams, StringParam } from 'use-query-params';
import { DesktopTitleCardList } from ".";
import Wrapper from "../wrapper/Wrapper";
import { debounce } from "lodash";
import { CATALOGUETYPES } from "../../constants";
import { upsellImpressionsGA } from "../../util";

var UpsellCardList = function UpsellCardList(props) {
  var _props$rendering = props.rendering,
      rendering = _props$rendering === void 0 ? {} : _props$rendering,
      _props$upsell = props.upsell,
      upsell = _props$upsell === void 0 ? [] : _props$upsell,
      _props$getUpsell = props.getUpsell,
      getUpsell = _props$getUpsell === void 0 ? function () {
    return "";
  } : _props$getUpsell,
      currentCategory = props.currentCategory,
      addToOrder = props.addToOrder,
      noLocation = props.noLocation,
      saveDefault = props.saveDefault,
      _props$params = props.params,
      params = _props$params === void 0 ? {} : _props$params,
      _props$isPromoProduct = props.isPromoProduct,
      isPromoProduct = _props$isPromoProduct === void 0 ? false : _props$isPromoProduct;
  var hide = typeof params === 'object' && params !== null ? params["Hide description"] : false;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      heading = _useState2[0],
      setHeading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      cards = _useState4[0],
      setCards = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasLoadedOnce = _useState6[0],
      setHasLoadedOnce = _useState6[1]; // const [rendered, setRendered] = useState(null)


  var dataSource = rendering.dataSource;
  var rendered = upsell[dataSource] || {};
  var layout = {};
  var getFeaturedWrapper = debounce(function (value) {
    getUpsell(value);
  }, 200);
  useEffect(function () {
    getFeaturedWrapper(dataSource);

    if (!hasLoadedOnce) {
      setHasLoadedOnce(true);
    }
  }, []);
  useEffect(function () {
    // const rendered = upsell[dataSource] || {};
    var cards;

    try {
      if (rendered.Products.length < parseInt(rendered.TotalCardsInRow)) {
        rendered.CardDisplayType = "carousel";
      }
    } catch (_unused) {} // promo call for Upsell Cards, check to prevent duplicate data being sent to gtm/ga


    if ((rendered === null || rendered === void 0 ? void 0 : rendered.UpsellCards) && !hasLoadedOnce) {
      upsellImpressionsGA(rendered.UpsellCards);
    }

    try {
      cards = rendered.UpsellCards.map(function (product) {
        var mapped = (product === null || product === void 0 ? void 0 : product.CatalogName) === (CATALOGUETYPES === null || CATALOGUETYPES === void 0 ? void 0 : CATALOGUETYPES.retail) ? mapProductRetail(product) : mapProduct(product);
        return {
          fields: mapped
        };
      });
      setCards(cards);
      var cardname = cards.fields.fullElement.DisplayName;
      rendered.layout = {
        background: "white",
        // rendered?.Background || "white",
        padding: (rendered === null || rendered === void 0 ? void 0 : rendered.Padding) || "medium"
      };
    } catch (_unused2) {
      cards = []; // setCards([])
    } //Handle if starting at in string (to make dynamic)
    //NOTE: Doesn't handle adjusted price becuase sometimes its 0 and would mess things up


    var heading = (rendered === null || rendered === void 0 ? void 0 : rendered.Heading) || "Don't forget your favorites";

    if (heading) {
      var position = heading.indexOf("Starting at"); //11 comes from length of starting at

      position !== -1 ? setHeading(handleStartingAt(heading, rendered.Products, position + 11)) : setHeading(heading);
    } // setRendered(data)

  }, [upsell, dataSource]);
  return cards.length ? /*#__PURE__*/React.createElement(Wrapper, {
    layout: rendered.layout,
    className: hide ? "cb-selected-cards__no-desc test" : ""
  }, /*#__PURE__*/React.createElement(DesktopTitleCardList, {
    title: {
      value: heading
    },
    simple: true,
    cards: cards,
    totalCardsInRow: rendered === null || rendered === void 0 ? void 0 : rendered.TotalCardsInRow,
    cardDisplayType: "carousel" //{rendered?.CardDisplayType}
    ,
    addToOrder: addToOrder,
    noLocation: noLocation,
    saveDefault: saveDefault,
    isPromoProduct: isPromoProduct
  })) : "";
};

export default UpsellCardList;

var handleStartingAt = function handleStartingAt(heading, cardsArray, positionOfStarting) {
  var listPriceArray = cardsArray.map(function (card) {
    return card.ListPrice;
  });
  var min = Math.min.apply(Math, _toConsumableArray(listPriceArray));
  return "".concat(heading.substring(0, positionOfStarting), " $").concat(min);
};